/* eslint-disable no-undef */
import Vue from 'vue'
import { namespace } from 'vuex-class'
import {EQUIPMENT_SET_BY_FIELD, MAINTENANCE_MODULE_NAMESPACE} from '../../../../store/maintenance'
import {IEquipment} from '../../../../models/equipment/equipment.model'

const MaintenanceStore = namespace(MAINTENANCE_MODULE_NAMESPACE)

export class EquipmentViewmodal extends Vue {
  @MaintenanceStore.Getter equipment : IEquipment

  @MaintenanceStore.Mutation(EQUIPMENT_SET_BY_FIELD)
  storeAssignValueForEquipment: (payload: IEquipment) => void;

  get Name () {
    return this.equipment.name
  }

  set Name (value: string) {
    this.storeAssignValueForEquipment({ name: value })
  }

  get Description (): string {
    return this.equipment.description
  }

  set Description (value: string) {
    this.storeAssignValueForEquipment({ description: value })
  }

  get Brand (): string {
    return this.equipment.brand
  }

  set Brand (value: string) {
    this.storeAssignValueForEquipment({ brand: value })
  }

  get Ref (): string {
    return this.equipment.reference
  }

  set Ref (value: string) {
    this.storeAssignValueForEquipment({ reference: value })
  }

  get Location (): string {
    return this.equipment.location
  }

  set Location (value: string) {
    this.storeAssignValueForEquipment({ location: value })
  }

  get NumberEquipment (): number {
    return this.equipment.number_equipment
  }

  set NumberEquipment (value: number) {
    let valToSave = typeof value === 'number' ? value : parseInt(value)
    this.storeAssignValueForEquipment({ number_equipment: valToSave })
  }

  get AcquisitionDate (): string {
    return this.equipment.acquisition_date
  }

  set AcquisitionDate (value: string) {
    this.storeAssignValueForEquipment({ acquisition_date: value })
  }

  get Block (): number {
    return this.equipment.fk_equipment_block
  }

  set Block (value: number) {
    this.storeAssignValueForEquipment({ fk_equipment_block: value })
  }

  get Apartment (): number {
    return this.equipment.fk_equipment_apartment
  }

  set Apartment (value: number) {
    this.storeAssignValueForEquipment({ fk_equipment_apartment: value })
  }

  get Lvl1 (): number {
    return this.equipment.fk_character_problem_lvl1
  }

  set Lvl1 (value: number) {
    this.storeAssignValueForEquipment({ fk_character_problem_lvl1: value })
  }

  get Lvl2 (): number {
    return this.equipment.fk_character_problem_lvl2
  }

  set Lvl2 (value: number) {
    this.storeAssignValueForEquipment({ fk_character_problem_lvl2: value })
  }

  get Contractors (): number[] {
    return this.equipment.contractors_assigned
  }

  set Contractors (value: number[]) {
    this.storeAssignValueForEquipment({ contractors_assigned: value })
  }

  get Disabled (): boolean {
    return this.equipment.disable
  }

  set Disabled (value: boolean) {
    this.storeAssignValueForEquipment({ disable: value })
  }
}



// WEBPACK FOOTER //
// ./src/containers/block/components/block-equipment-modal-vertical/equipment.viewmodal.ts